import styled from 'styled-components';
import media from '~/utils/media';
import On from '../../asset/check_on.svg';

export const Wrap = styled.div`
  padding: 32px 44px;
  background-color: #FCFCFC;
`;

export const CheckboxWrap = styled.div`
  margin: 0 auto;
  height: 24px;

  .checkbox-label {
    position: relative;
    display: flex;
    align-items: center;
    color: #484848;
    cursor: pointer;
    float: left;
    clear: both;
  }

  // ie input x 버튼 삭제
  input::-ms-clear {
    display: none;
  }

  input[type='checkbox'] {
    margin: 0;
    border: 0;
    width: 0;
    height: 0;
    -webkit-appearance: none;
  }

  input[type='checkbox']:checked {
    margin: 0;
    border: 0;
    -webkit-appearance: none;
  }

  //공백을위해 존재함
  input[type='checkbox'] + span {
    width: 24px;
    height: 24px;
    margin-right: 24px;
    
    ${media.mobileLarge`
      font-size: 10px;
    `}

    ${media.mobileMid`
      margin-right: 8px;
    `}

    ${media.mobileSmall`
       margin-right: 8px;
    `}
    display: inline-block;
    flex-shrink: 0;
  }

  span + p {
    color: #222222;
    font-weight: 700;
    font-size: 24px;
    line-height: 38px;
    color: #222222;
    
    @media only screen and (max-width: 640px) {
      font-size: 14px;
      line-height: 24px
    }    
  }
  // + 연산자를 통해 input태그옆의 span 태그에 접근할수있다.
  input[type='checkbox'] + span::before {
    content: '';
    width: 24px;
    height: 24px;
    position: absolute;
    display: inline-table;
    border: 1px solid #b0b0b0;
    border-radius: 2px;
    box-sizing: border-box;
    background-color: white;
    cursor: pointer;

  }
  input[type='checkbox']:checked + span::before {
    content: '';
    width: 24px;
    height: 24px;
    display: inline-table;
    border: 0;
    border-radius: 2px;
    position: absolute;
    background-image: url(${On});
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const TermsWrap = styled.ol`
  margin-top: 32px;
  list-style: decimal;
  list-style-position: outside;
  margin-left: 16px;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;

  @media only screen and (max-width: 640px) {
    font-size: 14px;
    line-height: 24px
  }    
`;
